<div *ngIf="!compact" class="brand-mark">
  <div *ngIf="newVersionAvailable" class="brand-mark__new-version">
    <span class="brand-mark__new-version__notification">
      {{ 'layout.newVersionAvailable.title' | crmTranslate }}
    </span>
    <button
      nz-button
      class="reload-app-button"
      (click)="reloadClicked.emit()"
      [nz-tooltip]="
        compact ? ('layout.newVersionAvailable.reload' | crmTranslate) : null
      "
    >
      <i nz-icon nzType="reload" nzTheme="outline"></i>
      <span
        class="reload-app-button__label"
        [ngClass]="{ collapsed: compact, expanded: !compact }"
      >
        {{ 'layout.newVersionAvailable.reload' | crmTranslate }}
      </span>
    </button>
  </div>
  <strong
    *ngIf="!compact"
    class="brand-mark__site-name"
    nz-tooltip
    [nzTooltipMouseEnterDelay]="0.5"
    [nzTooltipTitle]="moduleVersionsTmplt"
  >
    {{ brandName }}
  </strong>
  <span
    class="brand-mark__version"
    [class.invalid-version]="newVersionAvailable"
  >
    {{ version || '' }} {{ !production ? env : '' }}
  </span>
  <br />
  <ng-container *ngIf="showBrandLogo && !compact">
    <span>by</span>
    <img class="brand-mark__image" alt="logo" [src]="logoPath" />
  </ng-container>
</div>

<ng-template #moduleVersionsTmplt>
  <ng-container *ngIf="moduleVersions.length > 0">
    <div class="brand-mark__module-tooltip">
      <span *ngFor="let mod of moduleVersions" class="module-version">
        <span>{{ mod.module }}</span>
        <span>{{ mod.version }}</span>
      </span>
    </div>
  </ng-container>
</ng-template>
